import { render, staticRenderFns } from "./ResultInfoBox.vue?vue&type=template&id=09c170ba&scoped=true"
import script from "./ResultInfoBox.vue?vue&type=script&lang=ts"
export * from "./ResultInfoBox.vue?vue&type=script&lang=ts"
import style0 from "./ResultInfoBox.vue?vue&type=style&index=0&id=09c170ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09c170ba",
  null
  
)

export default component.exports